import { useContext } from 'react';
import { createContext } from 'react';

import { CompreJuntoProps } from '../@types/CompreJuntoProps';

export const CompreJuntoContext = createContext<CompreJuntoProps>({} as CompreJuntoProps);

CompreJuntoContext.displayName = 'CompreJunto';

const CompreJuntoProvider = (props: CompreJuntoProps) => (
	<CompreJuntoContext.Provider value={props}>{props.children}</CompreJuntoContext.Provider>
);

export const useCompreJunto = () => {
	const context = useContext(CompreJuntoContext);

	return context;
};

export default CompreJuntoProvider;
